import { Close, CloseOutlined } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import {
  registerWidget,
  DME,
  DMEData,
  dmeConfig,
  generalSettings,
  BlockRender,
  MiniRichText,
} from "dmeditor";
import { useState } from "react";

interface Entity {
  buttonText?: string;
  closeText?: string;
  content?: any;
}

export const ButtonModalRender = (props: DME.WidgetRenderProps<Entity>) => {
  const {
    blockNode: { data },
  } = props;

  const { buttonText, closeText, content } = data;
  const [shown, setShown] = useState(false);

  const open = (e: any) => {
    e.preventDefault();
    setShown(true);
  };

  return (
    <div className="">
      <a
        href="#"
        onClick={open}
        style={{ fontWeight: "bold", color: "#004abd" }}
      >
        {buttonText}
      </a>
      <Dialog open={shown} onClose={() => setShown(false)} fullWidth={true}>
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setShown(false)}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div>
            <MiniRichText
              mode="view"
              value={content}
              onValueChange={() => {}}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShown(false)}>
            {closeText || "Got it"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default () => {
  registerWidget(
    {
      type: "mf-button-modal",
      icon: "matchfit",
      name: "Button modal",
      category: "basic",
      settings: [
        { name: "Text", settingComponent: "input", property: ".buttonText" },
        {
          name: "Close text",
          settingComponent: "input",
          property: ".closeText",
        },
        {
          name: "Content",
          settingComponent: "rich-text",
          property: ".content",
        },
        ...generalSettings,
      ],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock<Entity> => {
          return {
            type: "mf-button-modal",
            data: {
              buttonText: "text",
              closeText: "Got it",
              content: [
                {
                  type: "paragraph",
                  children: [{ text: "" }],
                },
              ],
            },
          };
        },
      },
    },
    {
      render: ButtonModalRender,
    }
  );
};
